import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
export function HomeFooter() {
  return <footer className="bg-black text-white pt-16 pb-8 border-t border-gray-900" data-id="element-1061">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1062">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-1063">
          {/* Brand */}
          <div data-id="element-1064">
            <div className="flex items-center gap-3 mb-6" data-id="element-1065">
              <div className="relative w-10 h-10 overflow-hidden rounded-full border border-[#00D4FF] bg-black" data-id="element-1066">
                <img src="https://cdn.magicpatterns.com/uploads/fmBXjQm2BPtC5bTSRKvwCz/walkerlogo-gigapixel-cgi-3600w.png" alt="Walker's Martial Arts Logo" className="w-full h-full object-cover" data-id="element-1067" />
              </div>
              <div className="flex flex-col" data-id="element-1068">
                <span className="text-white font-bold text-base leading-none tracking-wide uppercase" data-id="element-1069">
                  Walker's
                </span>
                <span className="text-[#00D4FF] font-bold text-xs leading-none tracking-wider uppercase" data-id="element-1070">
                  Martial Arts
                </span>
              </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-xs" data-id="element-1071">
              "Where Families Kick Together"
              <br data-id="element-1072" />
              Proudly serving the Bloomington community and surrounding area
              since 1999.
            </p>
            <div className="flex gap-4" data-id="element-1073">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-[#00D4FF] hover:text-black transition-all" data-id="element-1074">
                <Facebook size={20} data-id="element-1075" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-[#00D4FF] hover:text-black transition-all" data-id="element-1076">
                <Instagram size={20} data-id="element-1077" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div data-id="element-1078">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-1079">
              Contact Us
            </h4>
            <ul className="space-y-4 text-gray-400" data-id="element-1080">
              <li className="flex items-start gap-3" data-id="element-1081">
                <MapPin className="w-5 h-5 text-[#00D4FF] shrink-0 mt-1" data-id="element-1082" />
                <span className="text-sm" data-id="element-1083">
                  1304 E. Empire Suite 2.
                  <br data-id="element-1084" />
                  Bloomington, Illinois 61701
                  <br data-id="element-1085" />
                  <span className="text-xs text-gray-500" data-id="element-1086">
                    (Inside the Regions Bank Complex at the intersection of
                    Empire & Towanda)
                  </span>
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-1087">
                <Phone className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-1088" />
                <a href="tel:3092422440" className="hover:text-white transition-colors" data-id="element-1089">
                  (309) 242-2440
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-1090">
                <Mail className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-1091" />
                <a href="mailto:walkerskicks@gmail.com" className="hover:text-white transition-colors" data-id="element-1092">
                  walkerskicks@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-1093">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-1094">
              Class Hours
            </h4>
            <ul className="space-y-2 text-gray-400" data-id="element-1095">
              <li className="flex justify-between" data-id="element-1096">
                <span data-id="element-1097">Monday - Thursday</span>
                <span className="text-white" data-id="element-1098">5:00 AM - 9:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-1099">
                <span data-id="element-1100">Friday</span>
                <span className="text-white" data-id="element-1101">5:00 AM - 7:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-1102">
                <span data-id="element-1103">Saturday</span>
                <span className="text-white" data-id="element-1104">9:00 AM - 2:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-1105">
                <span data-id="element-1106">Sunday</span>
                <span className="text-white" data-id="element-1107">8:00 AM - 12:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-1108">
          <p data-id="element-1109">
            &copy; {new Date().getFullYear()} Walker's Martial Arts. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-1110">
            <a href="#" className="hover:text-white transition-colors" data-id="element-1111">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-1112">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}